<h2>Need Help? See our FAQ’s</h2>        
<p>Read through popular questions and answers about {{Brand_Name}}.</p>

<div class="panel-group" id="accordion">
<div class="panel panel-default">
<div class="panel-heading">
<h3 class="panel-title">
<a data-toggle="collapse" data-parent="#accordion" href="#collapse1" aria-expanded="true"><span>&nbsp;</span>What is the {{Brand_Name}} prescription discount program?</a>
</h3>
</div>
<div id="collapse1" class="panel-collapse collapse show in">
<div class="panel-body">
    <p class="gap">{{Brand_Name}} prescription discount program is a free prescription discount program that helps users nationwide find the lowest prices on prescriptions at approximately 35,000 Pharmacies using the {{Brand_Name}} discount card and/or mobile app.</p>
    <p>At {{Brand_Name}}, we believe that everyone should have access to the lowest prices available for their medications, regardless of whether they have insurance or Medicare. The {{Brand_Name}} program helps users save up to 80% on prescriptions. The range of prescription discounts provided under this discount program will vary depending on the prescription and pharmacy where the prescription is purchased.  <strong>{{Brand_Name}} is not insurance</strong>. It is also not a Medicare prescription drug plan.</p>
</div>
</div>
</div>
<div class="panel">
<div class="panel-heading">
<h3 class="panel-title">
<a data-toggle="collapse" data-parent="#accordion" href="#collapse2" aria-expanded="false"><span>&nbsp;</span>Where does the {{Brand_Name}} prescription discount program work?</a>
</h3>
</div>
<div id="collapse2" class="panel-collapse collapse">
<div class="panel-body">
    <p>{{Brand_Name}} has a national network of drugstores and retail outlets, including Walgreens, CVS, Walmart, Costco, Kroger, Publix, and many others. That’s approximately 35,000 Pharmacies locations in the US that have partnered with {{Brand_Name}} to offer lower prescription prices.</p>
    <p>You can find participating pharmacies near you by searching for your zip code on {{Brand_Name}}.com, the {{Brand_Name}} mobile app or calling our member support line at 800-999-3053.</p>
</div>
</div>
</div>
<div class="panel panel-default">
<div class="panel-heading">
<h3 class="panel-title">
<a data-toggle="collapse" data-parent="#accordion" href="#collapse3" aria-expanded="false"><span>&nbsp;</span>Who can use {{Brand_Name}}?</a>
</h3>
</div>
<div id="collapse3" class="panel-collapse collapse">
<div class="panel-body">
    <p>Anyone in the US including the US Virgin Islands, Puerto Rico and US Territories.</p>
</div>
</div>
</div>
<div class="panel panel-default">
<div class="panel-heading">
<h3 class="panel-title">
    <a data-toggle="collapse" data-parent="#accordion" href="#collapse4" aria-expanded="false"><span>&nbsp;</span>Can the card be used multiple times?</a>
</h3>
</div>
<div id="collapse4" class="panel-collapse collapse">
<div class="panel-body">
    <p>Yes, you can use the card as many times as you want.</p>
</div>
</div>
</div>
<div class="panel panel-default">
<div class="panel-heading">
<h3 class="panel-title">
<a data-toggle="collapse" data-parent="#accordion" href="#collapse5" aria-expanded="false"><span>&nbsp;</span>Can I share the card with family and friends?</a>
</h3>
</div>
<div id="collapse5" class="panel-collapse collapse">
<div class="panel-body">
    <p>Yes, we encourage it! Not only can you print out copies of the card for your friends and family, but you can also take a pictures of the card with your phone and share them.</p>    
</div>
</div>
</div> 

<div class="panel panel-default">
    <div class="panel-heading">
    <h3 class="panel-title">
    <a data-toggle="collapse" data-parent="#accordion" href="#collapse6" aria-expanded="false"><span>&nbsp;</span>How much do consumers save with the {{Brand_Name}} prescription discount program?</a>
    </h3>
    </div>
    <div id="collapse6" class="panel-collapse collapse">
    <div class="panel-body">
        <p>The actual amount saved varies depending on the pharmacy and medication and is subject to change. Our pricing tool on {{Brand_Name}}.com and in the {{Brand_Name}} mobile app allows users to search for the best pricing in the area by zip code. If the pharmacy’s price is lower than the discount card price, they will be able to pay the lower price. The average savings off of retail prices is currently $35 per eligible prescription.</p>    
    </div>
    </div>
    </div> 

    <div class="panel panel-default">
        <div class="panel-heading">
        <h3 class="panel-title">
        <a data-toggle="collapse" data-parent="#accordion" href="#collapse7" aria-expanded="false"><span>&nbsp;</span>Does the card expire?</a>
        </h3>
        </div>
        <div id="collapse7" class="panel-collapse collapse">
        <div class="panel-body">
            <p>No, the {{Brand_Name}} discount card does not expire.</p>    
        </div>
        </div>
        </div> 

        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse8" aria-expanded="false"><span>&nbsp;</span>Is the {{Brand_Name}} prescription discount program really free? Are there any fees associated with using this card?</a>
            </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
            <div class="panel-body">
                <p>The {{Brand_Name}} prescription discount program is free. There are NO membership fees, sign-up fees or eligibility requirements.</p>    
            </div>
            </div>
        </div> 

        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse9" aria-expanded="false"><span>&nbsp;</span>If I have insurance and/or Medicare, can I still use the {{Brand_Name}} card?</a>
            </h3>
            </div>
            <div id="collapse9" class="panel-collapse collapse">
            <div class="panel-body">
                <p>Yes! You can use the {{Brand_Name}} prescription discount program even if you are on Medicare or have insurance. How?</p>
                <ul>
                    <li>Sometimes, our prices are lower than typical co-pays.</li>
                    <li>Sometimes insurance doesn't cover a certain drug.</li>
                    <li>Sometimes a consumer can’t afford their medication due to a high deductible.</li>
                </ul>   
                <p>One important note: if you use the {{Brand_Name}} price, it will not count again your deductible, out-of-pocket maximums, or the so-called Medicare "donut hole" because the {{Brand_Name}} prescription discount program is being used instead of Medicare and/or your insurance.</p> 
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse10" aria-expanded="false"><span>&nbsp;</span>Can the {{Brand_Name}} prescription discount program be used <u>together</u> with insurance and/or Medicare?</a>
            </h3>
            </div>
            <div id="collapse10" class="panel-collapse collapse">
            <div class="panel-body">
                <p>No, the {{Brand_Name}} card cannot be used together with insurance, it is used <u>instead</u> of insurance and/or Medicare. The discounted rates cannot be combined.</p>    
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse11" aria-expanded="false"><span>&nbsp;</span>Do {{Brand_Name}} purchases count towards my insurance deductible or Medicare Out-of-Pocket Maximums or the coverage gap ("donut hole")?</a>
            </h3>
            </div>
            <div id="collapse11" class="panel-collapse collapse">
            <div class="panel-body">
                <p>No, when you use the {{Brand_Name}} card instead of insurance and/or Medicare, your prescription payment will not be applied to your insurance or Medicare deductible or any out-of-pocket maximums.</p>    
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse12" aria-expanded="false"><span>&nbsp;</span>Can a Health Savings Account (HSA) be used to purchase prescriptions?</a>
            </h3>
            </div>
            <div id="collapse12" class="panel-collapse collapse">
            <div class="panel-body">
                <p>Yes! If you have a Health Savings Account (HSA) and a prescription is eligible to be purchased with HSA funds, you can use funds from your HSA to purchase prescriptions using their {{Brand_Name}} card.</p>    
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse13" aria-expanded="false"><span>&nbsp;</span>Does the card work on pet prescriptions?</a>
            </h3>
            </div>
            <div id="collapse13" class="panel-collapse collapse">
            <div class="panel-body">
                <p>At {{Brand_Name}}, we realize that pets are often just as much a part of the family as mom, dad and the kids. Using the same {{Brand_Name}} card they use for their own prescriptions; cardholders can save money on the prescriptions needed for their furry friend. Just have your vet write out the prescription and take it to the pharmacist.</p>    
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse14" aria-expanded="false"><span>&nbsp;</span>Is the {{Brand_Name}} prescription discount program Insurance?</a>
            </h3>
            </div>
            <div id="collapse14" class="panel-collapse collapse">
            <div class="panel-body">
                <p><strong>No. The {{Brand_Name}} prescription discount program is not insurance</strong>. The {{Brand_Name}} prescription discount program does not satisfy the coverage mandate tied to the Affordable Care Act.</p>    
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse15" aria-expanded="false"><span>&nbsp;</span>How does the {{Brand_Name}} prescription discount program work?</a>
            </h3>
            </div>
            <div id="collapse15" class="panel-collapse collapse">
            <div class="panel-body">
                <p>{{Brand_Name}} works with its pharmacy partners to negotiate low prices on prescriptions directly with major pharmacies for the {{Brand_Name}} program. We pass those savings directly to our users at no cost to them! To use the {{Brand_Name}} prescription discount program, simply search for a prescription on the {{Brand_Name}} website or mobile app, compare prices between nearby pharmacies, and get your free {{Brand_Name}} prescription discount card. Bring the card when you fill your prescription and show it to the pharmacist. Your savings will be reflected at checkout.</p>    
            </div>
            </div>
        </div> 
                
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse16" aria-expanded="false"><span>&nbsp;</span>Is my privacy protected?</a>
            </h3>
            </div>
            <div id="collapse16" class="panel-collapse collapse">
            <div class="panel-body">
                <p>{{Brand_Name}} employs strict data privacy policies to ensure the protection of data and privacy of our millions of members. The {{Brand_Name}} program does not store or sell personalized user data to any third parties.</p>    
            </div>
            </div>
        </div> 

        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse17" aria-expanded="false"><span>&nbsp;</span>Are {{Brand_Name}}’s listed prices guaranteed?</a>
            </h3>
            </div>
            <div id="collapse17" class="panel-collapse collapse">
            <div class="panel-body">
                <p>The vast majority of the time, the prices listed on {{Brand_Name}}.com or on the {{Brand_Name}} mobile app very closely match the prices you will pay at the pharmacy.<br/>However, the availability of specific drugs at a local level can occasionally cause price differences. For example, a pharmacy may fill your prescription with a different but equivalent drug, manufactured by a different company than what the {{Brand_Name}} program is listing, which may lead to a price difference.<br/>We do our best to determine and price the most popular drug used to fill prescriptions. The prices we publish are our best estimate, based on multiple sources of information. However, we cannot guarantee the price we display will exactly match the price you receive at the pharmacy.<br/>For an exact price on a prescription, please contact your pharmacy and provide the BIN/GRP/PCN numbers shown on your {{Brand_Name}} card.</p>    
            </div>
            </div>
        </div> 

        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse18" aria-expanded="false"><span>&nbsp;</span>Are my prescriptions discounted with {{Brand_Name}}?</a>
            </h3>
            </div>
            <div id="collapse18" class="panel-collapse collapse">
            <div class="panel-body">
                <p>{{Brand_Name}} can save you money over a pharmacy’s retail price on a wide variety of prescriptions you receive from your doctor. We currently cover more than 10,000 prescriptions. To find the exact price you will pay, visit {{Brand_Name}}.com or download the {{Brand_Name}} app and search for your specific prescriptions.<br/>Remember to filter by pill quantity, pill count, and whether it’s brand name vs generic.</p>    
            </div>
            </div>
        </div> 
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse19" aria-expanded="false"><span>&nbsp;</span>How does {{Brand_Name}} set prescription medication prices?</a>
            </h3>
            </div>
            <div id="collapse19" class="panel-collapse collapse">
            <div class="panel-body">
                <p>Through its pharmacy partners, {{Brand_Name}} works with pharmacies to negotiate low prices for our users. Our team also analyzes consumer demand for medications and makes pricing adjustments each month, so it’s always a good idea to check {{Brand_Name}}.com for current prices before purchasing your prescriptions.</p>    
            </div>
            </div>
        </div>         
        <div class="panel panel-default">
            <div class="panel-heading">
            <h3 class="panel-title">
            <a data-toggle="collapse" data-parent="#accordion" href="#collapse20" aria-expanded="false"><span>&nbsp;</span>Are over the counter medications covered?</a>
            </h3>
            </div>
            <div id="collapse20" class="panel-collapse collapse">
            <div class="panel-body">
                <p>{{Brand_Name}} prescription discounts are only available for prescription medications. Some over-the-counter drugs, such as ibuprofen, have stronger forms that require a prescription, and those forms may be covered.</p>    
            </div>
            </div>
        </div> 
</div>